import { TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const AutoResizableTextArea = ({ 
  label, 
  rightElementStyles, 
  rightElement, 
  sx: externalSx = {}, // Destructure with default empty object
  ...props 
}) => {
  const [text, setText] = useState(props.value || "");
  const textAreaRef = useRef(null);

  useEffect(() => {
    if (textAreaRef.current) {
      const textarea = textAreaRef.current.querySelector('textarea');
      if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }
    }
  }, [props.value]);

  const handleChange = (e) => {
    setText(e.target.value);
    if (props.onChange) props.onChange(e);
  };

  // Combine sx props with INTERNAL styles taking precedence
  const combinedSx = {
    ...externalSx, // External styles first (will be overridden by internal ones)
    width: "100%",
    '& .MuiInputBase-root': {
      minHeight: "40px",
      alignItems: "flex-start",
      ...externalSx['& .MuiInputBase-root'], // Merge nested objects
    },
    '& textarea': {
      minHeight: "40px !important",
      maxHeight: "250px !important",
      overflowY: "auto !important",
      resize: "none !important",
      ...externalSx['& textarea'], // Merge nested objects
    },
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <TextField
        label={label}
        inputRef={textAreaRef}
        value={text}
        onChange={handleChange}
        multiline
        sx={combinedSx}
        style={props.style}
        {...props}
      />
      
      {rightElement && <div style={rightElementStyles}>{rightElement}</div>}
    </div>
  );
};

export default AutoResizableTextArea;